import { csrfHeaders } from './csrf'

// --- Credentials ---

export async function getCredentialsStatus(): Promise<{
  apple_configured: boolean
}> {
  const res = await fetch('/api/mobile_credentials/status', { headers: csrfHeaders() })
  if (!res.ok) throw new Error('Failed to fetch credentials status')
  return res.json()
}

export async function storeAppleCredentials(credentials: {
  asc_key_id: string
  asc_issuer_id: string
  asc_key_content: string
  apple_team_id: string
  apple_team_type: string
  company_name?: string
}): Promise<void> {
  const res = await fetch('/api/mobile_credentials/apple', {
    method: 'POST',
    headers: csrfHeaders(),
    body: JSON.stringify(credentials),
  })
  if (!res.ok) {
    const data = await res.json()
    throw new Error(data.error || 'Failed to store Apple credentials')
  }
}

export async function deleteCredentials(platform: 'apple'): Promise<void> {
  const res = await fetch(`/api/mobile_credentials/${platform}`, {
    method: 'DELETE',
    headers: csrfHeaders(),
  })
  if (!res.ok) throw new Error('Failed to delete credentials')
}

// --- Mobile Publish ---

export interface MobileDeployment {
  id: number
  platform: 'ios'
  status: 'pending' | 'building' | 'submitting' | 'live' | 'failed'
  eas_build_id: string | null
  error_message: string | null
  build_started_at: string | null
  build_completed_at: string | null
  submit_completed_at: string | null
  duration: number | null
  created_at: string
}

export interface MobileConfig {
  ios_bundle_id: string | null
  expo_project_id: string | null
}

export interface MobilePublishStatus {
  ios: MobileDeployment | null
  config: MobileConfig
}

export async function getMobilePublishStatus(projectId: number): Promise<MobilePublishStatus> {
  const res = await fetch(`/api/projects/${projectId}/mobile/status`, { headers: csrfHeaders() })
  if (!res.ok) throw new Error('Failed to fetch mobile publish status')
  return res.json()
}

export async function configureMobilePublish(projectId: number, config: {
  ios_bundle_id?: string
}): Promise<void> {
  const res = await fetch(`/api/projects/${projectId}/mobile/configure`, {
    method: 'POST',
    headers: csrfHeaders(),
    body: JSON.stringify(config),
  })
  if (!res.ok) {
    const data = await res.json()
    throw new Error(data.error || 'Failed to configure')
  }
}

export async function triggerMobilePublish(projectId: number, platforms: string[]): Promise<{
  deployments: MobileDeployment[]
}> {
  const res = await fetch(`/api/projects/${projectId}/mobile/deploy`, {
    method: 'POST',
    headers: csrfHeaders(),
    body: JSON.stringify({ platforms }),
  })
  if (!res.ok) {
    const data = await res.json()
    throw new Error(data.error || 'Failed to trigger deploy')
  }
  return res.json()
}

export async function retryMobileSubmit(projectId: number, ascAppId: string): Promise<{
  deployments: MobileDeployment[]
}> {
  const res = await fetch(`/api/projects/${projectId}/mobile/retry_submit`, {
    method: 'POST',
    headers: csrfHeaders(),
    body: JSON.stringify({ asc_app_id: ascAppId }),
  })
  if (!res.ok) {
    const data = await res.json()
    throw new Error(data.error || 'Failed to retry submit')
  }
  return res.json()
}
